import React, { Component } from 'react'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_BUQUES } from '../../../config/tables'

export class TablaBuquesView extends Component {
  render () {
    return (
      <div>
        <MuiTable id={TABLA_BUQUES} />
      </div>
    )
  }
}
